<template>
  <router-view />
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
export default Vue.extend({
  name: 'App',
  created() {
    this.initJssdk()
  },
  data() {
    return {
      jssdkParam: {
        appId: '',
        nonceStr: '',
        signature: '',
        timestamp: ''
      }
    }
  },

  methods: {
    async initJssdk() {
      try {
        const res = await axios.get(
          `/vb/user/jsapi_param?url=${encodeURI(window.location.href)}`
        )
        const resData = res.data
        if (resData.code < 20000) {
          throw new Error(resData.message)
        }
        this.jssdkParam = resData.data

        // eslint-disable-next-line
        const { appId, nonceStr, signature, timestamp } = this.jssdkParam

        wx.config({
          appId,
          timestamp,
          nonceStr,
          signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'ononMenuShareQZone'
          ] // 必填，需要使用的JS接口列表
        })
        wx.ready(function() {
          const shareTitle = '达芬奇汽车专用上传系统'

          const shareDesc =
            '适配本田车型｜手机上传图片，车机一键下载，智能互联，方便快捷'
          const shareLink = `https://up.tssss.cn`
          const shareImgUrl = 'https://up.tssss.cn/xzslogo.png'

          const shareConfig = {
            title: shareTitle,
            desc: shareDesc,
            link: shareLink,
            imgUrl: shareImgUrl
          }
          wx.updateAppMessageShareData(shareConfig)
          wx.updateTimelineShareData(shareConfig)
          wx.onMenuShareWeibo(shareConfig)
          wx.onMenuShareQZone(shareConfig)
          wx.onMenuShareTimeline(shareConfig)
          wx.onMenuShareAppMessage(shareConfig)
          wx.onMenuShareQQ(shareConfig)
          wx.onMenuShareQZone(shareConfig)
        })
      } catch (e) {
        // nothing
        console.error(e)
      }
    }
  }
})
</script>
